import React from 'react';

const Spinner = () => {
  return (
    <div className="u-mt-4 u-flex u-justify-center">
      <img src="https://alcoholchange.org.uk/assets/build/svg/black-icons/research.svg" alt="" className="icon-research" />
      <img src="https://alcoholchange.org.uk/assets/build/svg/black-icons/alcopop-bottle.svg" alt="" className="u-mt-4 icon-bottle" />
      <img src="https://alcoholchange.org.uk/assets/build/svg/black-icons/trends.svg" alt="" className="icon-society" />
    </div>
  );
};

export default Spinner;
